module.exports = __webpack_public_path__ + "static/img/PARIS_OAK.8455c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/PARIS_OAK.jpg
// module id = nN8l
// module chunks = 0